import styled from 'styled-components'
import { TypeBodyM, TypeCaptionM } from '../../styles/mixins'
import SanityContent from '../sanity/content/SanityContent'

const SidebarText: React.FC<any> = ({ sidebar }: any) => {
  const {title, content} = sidebar.content;
  return (
    <Container>
      {title && <h2>{title}</h2>}
      <Content blocks={content} layout="DEFAULT" />
    </Container>
  )
}

const Container = styled.nav`
  h2 {
    ${TypeCaptionM}
    margin-bottom: var(--spacing-16);
  }
`

const Content = styled(SanityContent)`
  ${TypeBodyM}
  
  >* + * {
    margin-top: 1em;
  }
`

export default SidebarText
